import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs/operators';

import { AsyncJobType, CurrentUserEntityActions } from '@recruitee/account/data';
import { AsyncJobActions } from '@recruitee/async-job/data';

import { JobRequisitionsActions } from './job-requisitions/job-requisitions.store';
import { JobsFullActions } from './jobs/jobs-full.store';
import { JobItemsActions } from './jobs/jobs.store';
import { OfferItemsActions } from './offers.actions';

@Injectable({ providedIn: 'root' })
export class OffersGlobalEffects {
  private asyncJobActiveCollectionUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AsyncJobActions.finish),
      filter(
        ({ payload }) =>
          AsyncJobType.BulkOffersFollow === payload.job.type ||
          AsyncJobType.BulkOffersUnfollow === payload.job.type,
      ),
      map(() => OfferItemsActions.fetchActiveCollections()),
    ),
  );

  private asyncJobRetrieveBulkOffers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AsyncJobActions.finish),
      filter(({ payload }) => AsyncJobType.BulkOffersRetrieveArchived === payload.job.type),
      map(() => CurrentUserEntityActions.fetch()),
    ),
  );

  private asyncJobArchived$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AsyncJobActions.finish),
      filter(
        ({ payload }) =>
          AsyncJobType.BulkOffersDeleteArchived === payload.job.type ||
          AsyncJobType.BulkOffersRetrieveArchived === payload.job.type,
      ),
      map(() => JobItemsActions.fetchArchivedCollection()),
    ),
  );

  private jobRequisitionAssignmentChanged$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        JobRequisitionsActions.assignSuccess,
        JobRequisitionsActions.unassignSuccess,
        JobRequisitionsActions.assignOpeningsSuccess,
      ),
      map(({ payload }) => JobsFullActions.fetchOne({ payload: { id: payload.offerId } })),
    ),
  );

  private dataCopiedFromRequisitionToJob$ = createEffect(() =>
    this.actions$.pipe(
      ofType(JobRequisitionsActions.copyDataSuccess),
      map(({ payload }) =>
        JobRequisitionsActions.fetchOne({ payload: { offerId: payload.data.offer.id } }),
      ),
    ),
  );

  constructor(private actions$: Actions) {}
}
